import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { WebDispatch, setDataFilterCriteria, setTenantDataFilterCriteria } from '../actions';
import { WebReduxState } from '../reducers';
import WizardFilterPage from './WizardFilterPage';
import { WizardDescription, TenantWizardDescription } from './WizardDescription';

const Header = () => <FormattedMessage id="DataFilter.place" defaultMessage="Line" />;

const optionsSelector = (state: WebReduxState) => state.inform.dataFilter.availableOptions.lines;
const selectedOptionsSelector = (state: WebReduxState) => state.inform.dataFilter.criteria.lines;
const handleSelectionChange = (dispatch: WebDispatch, options: string[]) => {
  dispatch(setDataFilterCriteria('lines', options));
};

const optionsSelectorTenantMode = (state: WebReduxState) => state.admin.tenants.availableOptions.lines;
const selectedOptionsSelectorTenantMode = (state: WebReduxState) => state.admin.tenants.tenantFilter.lines;
const handleSelectionChangeTenantMode = (dispatch: WebDispatch, options: string[]) => {
  dispatch(setTenantDataFilterCriteria('lines', options));
};

type Props = {
  tenantMode?: boolean;
};

export default function WizardLinesFilterPage({ tenantMode }: Props) {
  return (
    <WizardFilterPage
      HeaderComponent={Header}
      DescriptionComponent={tenantMode ? TenantWizardDescription : WizardDescription}
      optionsSelector={tenantMode ? optionsSelectorTenantMode : optionsSelector}
      selectedOptionsSelector={tenantMode ? selectedOptionsSelectorTenantMode : selectedOptionsSelector}
      onSelectionChanged={tenantMode ? handleSelectionChangeTenantMode : handleSelectionChange}
    />
  );
}
